import {
  GetOrganizationRestrictionsRequest,
  GetOrganizationRestrictionsResponse,
  GetUserRestrictionsAsAdminRequest,
  GetUserRestrictionsAsAdminResponse,
} from "@safetyculture/s12-apis-connect-web/s12/restrictions/admin/v1/restrictions_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

type GetUserRestrictionsParams = {
  userId: string;
  restrictionNames: string[];
};

export const getUserRestrictions = async (
  { userId, restrictionNames }: GetUserRestrictionsParams,
  headers: Record<RequestMetadata, string>
): Promise<GetUserRestrictionsAsAdminResponse> => {
  const req = new GetUserRestrictionsAsAdminRequest({
    userId,
    restrictionNames,
  });

  return supportServiceConnectClient.getUserRestrictions(req, { headers });
};

type GetOrgRestrictionsParams = {
  organizationId: string;
  restrictionNames: string[];
};

export const getOrgRestrictions = async (
  { organizationId, restrictionNames }: GetOrgRestrictionsParams,
  headers: Record<RequestMetadata, string>
): Promise<GetOrganizationRestrictionsResponse> => {
  const req = new GetOrganizationRestrictionsRequest({
    organizationId,
    restrictionNames,
  });

  return supportServiceConnectClient.getOrgRestrictions(req, { headers });
};
